import { IPanelProps } from 'core/decorators/Panel';

export function flattenLayout(layout: any) {
	let panels: Array<IPanelProps<any>> = [];

	visitPanels(layout.children, (p) => {
		panels.push(p);
	});

	panels = panels.map((p: any) => {

		if(p.children && p.children.length > 0) {
			const children = p.children.map((c) => {
				return c.instance;
			});

			return {...p, children};
		}

		return {...p};
	});

	return {...layout, children: panels, top: layout.children.map((c) => c.instance)};
}

function visitPanels(panels: any[], callback: any): void {

	panels.forEach((p: any) => {

		if(p.children && p.children.length > 0) {
			visitPanels(p.children, callback);
		}

		callback(p);
	});
}

export function explodeLayout(layout) {

	const children = [...layout.top.map((p) => (
		explodeChildren(p, [...layout.children])
	))];

	return {...layout, children};
}

function explodeChildren(instance: any, panels: any[]): any {

	const p: any = panels.find((c) => c.instance === instance);

	if(p !== undefined) {

		if(typeof p.children !== 'undefined' && p.children.length > 0) {
			p.children = p.children.map((c) => explodeChildren(c, panels));
		}

		return p;

	} else {
		console.warn("cannot find chid");
	}
}

export default class LayoutUtil {

	public static visitPanels(

		panels: { [instance: string]: object; },

		instance: string,

		callback: (panel: any, instance: string, index: number, ancestors: string[]) => boolean, // return false to stop recursing

		index: number = 0,

		ancestors: string[] = []

	): void {
		if (panels[instance] && callback(panels[instance], instance, index, ancestors)) {
			const childIds = this.getChildIds(panels[instance]);

			if (childIds.length > 0 ) {
				childIds.forEach((cid, i) => this.visitPanels(panels, cid, callback, i, [...ancestors, instance]));
			}
		}
	}

	public static visitLayout(store: any, callback: (panel: any, instance: string, index: number, ancestors: string[]) => boolean) {
		const { layout = [], config: { panels = {} }} = store;
		for (const inst of layout) {
			this.visitPanels(panels, inst, callback);
		}
	}

	/**
	 * Find descendent panels in the heirarchy. optionally filter by type and
	 * @param panels 		// panel config object from store
	 * @param instance 		// instance to start from
	 * @param panelIds 		// panel ids to filter to (e.g. ['page'] to find page structure)
	 * @param closest 		// stop recursing after one is found
	 */
	public static findDescendents(

		panels: { [instance: string]: object; },

		instance: string,

		panelIds?: string[],

		closest?: boolean

	): string[] {

		const descendents: string[] = [];

		this.visitPanels(panels, instance, (panel, inst) => {
			if (instance !== inst && (!panelIds || panelIds.indexOf(panel.id) > -1)) {
				descendents.push(inst);

				return !closest;
			}

			return true;
		});

		return descendents;
	}

	public static getChildIds(panel: any): string[] {
		const instances = [];

		if (panel.children) {
			panel.children.forEach((cid: string) => instances.push(cid));
		}

		if (panel.layout && panel.layout.columns) {
			panel.layout.columns.forEach(({containerInstance}) => instances.push(containerInstance));
		}

		return instances;
	}

}



// WEBPACK FOOTER //
// ./src/core/util/LayoutUtil.ts